import React from "react";
import { FiX } from "react-icons/fi";
import DatePicker from "./DatePicker";
import Button from "./Button";
import "./DateRangeFilter.css";

export interface DateRange { startDate: string; endDate: string; }
interface Props extends DateRange {
  onChange: (value: DateRange) => void;
  startLabel?: string;
  endLabel?: string;
  disabled?: boolean;
}

export default function DateRangeFilter({ startDate, endDate, onChange, startLabel = "From", endLabel = "Through", disabled }: Props) {
  return <div className="navo-date-range" role="group" aria-label="Date range filter">
    <DatePicker label={startLabel} value={startDate} max={endDate || undefined} disabled={disabled}
      onChange={value => onChange({ startDate: value, endDate })} />
    <span className="navo-date-range__dash" aria-hidden="true">—</span>
    <DatePicker label={endLabel} value={endDate} min={startDate || undefined} disabled={disabled}
      onChange={value => onChange({ startDate, endDate: value })} />
    {(startDate || endDate) && <Button variant="text" size="small" disabled={disabled} startIcon={<FiX />}
      onClick={() => onChange({ startDate: "", endDate: "" })} aria-label="Clear date range">Clear</Button>}
  </div>;
}
